export default __webpack_public_path__ + "static/media/k-niimi.49dd2281.webp";